import React, { useEffect, useRef } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import routes from "../../routes";
import { Grid } from "@mui/material";
import { setPageTitle, getPageTitleFromRoute, updateCompanyNameFromToken } from "../../utils/pageTitle";
import { attachSystemColorSchemeListener } from "../../utils/adminThemePreference";

const Auth = () => {
  const mainContent = useRef(null);
  const location = useLocation();

  /* External pages always follow OS/browser theme only — not saved profile Light/Dark. */
  useEffect(() => {
    const applyAuthAreaTheme = (systemDark) => {
      if (systemDark) {
        document.body.classList.add("admin-dark-active");
      } else {
        document.body.classList.remove("admin-dark-active");
      }
    };
    applyAuthAreaTheme(window.matchMedia("(prefers-color-scheme: dark)").matches);
    return attachSystemColorSchemeListener(applyAuthAreaTheme);
  }, []);

  useEffect(() => {
    // JOB-3245: updateCompanyNameFromToken is handled by ProtectedRoute (or not
    // applicable on auth pages). Just set the title synchronously.
    const title = getPageTitleFromRoute(location.pathname);
    setPageTitle(title);
  }, []);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) {
      mainContent.current.scrollTop = 0;
    }
    
    const title = getPageTitleFromRoute(location.pathname);
    setPageTitle(title);
  }, [location]);

  const getRoutes = (routes) => {
    return routes?.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={prop?.path} element={prop?.component} key={key} exact />
        );
      }
      return null;
    });
  };

  return (
    <Grid>
      <Grid className="main-content" ref={mainContent}>
        <Grid style={{ width: "100%" }}>
          <Routes>
            {getRoutes(routes)}
            <Route path="*" element={<Navigate to="/auth/login" replace />} />
          </Routes>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Auth;
